import { FC, useState } from 'react';
import clsx from 'clsx';
import { useStyles } from './styles';
import { ClientFormProps } from './types';
import {
  TextField,
  Button,
  FormControlLabel,
  FormControl,
  Input,
  InputLabel,
  InputAdornment,
  IconButton,
  NativeSelect,
  Grid,
  Paper,
  Modal,
  Typography,
  Checkbox,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CloseIcon from '@material-ui/icons/Close';
import { observer } from 'mobx-react-lite';
//import { useStore } from 'hooks/useRootStore';

export const ClientForm: FC<ClientFormProps> = observer(({ formLabel, buttonLabel, openModal, handleCloseModal }) => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [password, setPassword] = useState<string>('');
  const [passwordConfirm, setPasswordConfirm] = useState<string>('');
  //const { userStore } = useStore();

  return (
    <Modal className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={openModal}>
      <Paper className={classes.paper} elevation={3}>
        <Grid container justify='space-between' spacing={2}>
          <p className={classes.title}>{formLabel}</p>
          <IconButton onClick={() => handleCloseModal()}>
            <CloseIcon color='primary' />
          </IconButton>
        </Grid>
        <Grid container spacing={2}>
          <TextField
            className={classes.margin}
            autoComplete='fname'
            required
            fullWidth
            id='organizationName'
            label='Or ganization Name'
            autoFocus
          />
          <TextField
            className={classes.margin}
            required
            fullWidth
            id='organizationDomain'
            label='Organization Domain'
          />
          <TextField className={classes.margin} required fullWidth id='email' label='Email' autoComplete='email' />
          <FormControl className={clsx(classes.margin, classes.formControl)} required>
            <InputLabel htmlFor='password'>Password</InputLabel>
            <Input
              id='password'
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton aria-label='toggle password visibility' onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl className={clsx(classes.margin, classes.formControl)} required>
            <InputLabel htmlFor='password'>Confirm Password</InputLabel>
            <Input
              id='password-confirm'
              type={showPassword ? 'text' : 'password'}
              value={passwordConfirm}
              onChange={(event) => setPasswordConfirm(event.target.value)}
            />
          </FormControl>
          <Typography className={classes.margin} align='center' display='block' variant='button'>
            Number of user accounts to provision in the cloud:
          </Typography>
          <NativeSelect className={classes.margin} fullWidth>
            <option aria-label='None' value={0} />
            <option value={1}>0-100</option>
            <option value={2}>0-1000</option>
          </NativeSelect>
          <Typography className={classes.margin} align='left' display='block' variant='button'>
            Select for choose subscription:
          </Typography>
          <NativeSelect className={classes.margin} fullWidth>
            <option aria-label='None' value={0} />
            <option value={1}>50</option>
            <option value={2}>100</option>
          </NativeSelect>
          <Grid container direction='column' justify='flex-start'>
            <Typography className={classes.footnote} align='left'>
              1 year and then you can switch to some package:
            </Typography>
            <FormControlLabel className={classes.margin} control={<Checkbox />} label='I agree terms of service' />
          </Grid>
        </Grid>
        <Button
          className={classes.margin}
          fullWidth
          variant='contained'
          color='primary'
          onClick={() => handleCloseModal()}>
          {buttonLabel}
        </Button>
      </Paper>
    </Modal>
  );
});
